import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { Checkbox } from "@components/v2";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface SortableItemProps {
  id: string;
  label: string;
  checked: boolean;
  disabled?: boolean;
  sortable?: boolean;
  className?: string;
  onChange?: (val: boolean) => void;
}

export const MetricItem = ({
  id,
  label,
  checked,
  disabled,
  sortable = true,
  className,
  onChange,
}: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={twMerge(
        clsx(
          "flex items-center gap-2.5 text-xs h-8 rounded px-2 bg-v2-primary relative",
          {
            "bg-v2-highlight cursor-auto": disabled,
            "hover:bg-v2-secondary": !disabled,
            "z-[99] bg-v2-secondary shadow-sm": isDragging,
          },
        ),
        className,
      )}
    >
      <div className="cusrsor-auto flex items-center">
        <Checkbox
          className={clsx({
            "text-v2-disabled": disabled,
          })}
          disabled={disabled}
          checked={checked}
          onChange={(e) => {
            onChange?.(e.target.checked);
          }}
        />
      </div>
      <div className="flex-1 truncate">{label}</div>
      {sortable && (
        <div
          className={clsx("shrink-0", {
            "cursor-grab": !disabled,
            "cursor-auto": disabled,
          })}
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
        >
          <i className="fa-solid fa-grip-dots text-v2-secondary"></i>
        </div>
      )}
    </div>
  );
};
